import { ThemeProvider } from '@/contexts/ThemeContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Segments from './components/Segments';
import Differentials from './components/Differentials';
import ProductProof from './components/ProductProof';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <ThemeProvider>
      <main className="min-h-screen">
        <Header />
        <Hero />
        <Solutions />
        <Segments />
        <Differentials />
        <ProductProof />
        <Contact />
        <Footer />
      </main>
    </ThemeProvider>
  );
}
